module.exports = __webpack_public_path__ + "img/arrow.b5b8a2bc.svg";